// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'reply-solid';

export const Component = () => (
  <path d='M.5 10.88c0-.316.094-.496.281-.63l7.547-7.115A.433.433 0 0 1 8.656 3c.329 0 .47.135.47.45v4.052c4.03 0 7.546 1.26 10.546 3.828 2.953 2.566 4.594 5.988 4.828 10.175v.045c0 .315-.14.45-.469.45a.5.5 0 0 1-.422-.225c-1.593-2.296-3.844-4.232-6.703-5.763-2.812-1.441-5.39-2.162-7.78-2.162v4.098c0 .27-.141.405-.47.405-.14 0-.28-.044-.328-.09L.781 11.464a.715.715 0 0 1-.281-.585Z' />
);

export const viewBox = '0 0 25 25';
